import React from 'react';
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const PreScriptsIndicator = ({preScripts}) => (
    preScripts.length > 0 ? (
        <span>
            <FontAwesomeIcon icon="sign-in-alt" />
        </span>
    ) : null
);

PreScriptsIndicator.propTypes = {
    preScripts: PropTypes.array.isRequired,
};

export default PreScriptsIndicator;
